function initAddressAutocomplete() {

    let suggestions = [];

    function fetchSuggestions(query) {
        if (!query || query.length < 2) return;

        fetch(`https://api.postcodes.io/postcodes?q=${encodeURIComponent(query)}`)
            .then(res => res.json())
            .then(data => {

                suggestions = data.result || [];

                const datalist = document.getElementById("address-suggestions");
                if (!datalist) return;

                datalist.innerHTML = "";

                suggestions.forEach(item => {
                    const option = document.createElement("option");
                    option.value = item.postcode;
                    datalist.appendChild(option);
                });

            })
            .catch(console.error);
    }

    const postcodeInput = document.getElementById("postcode");

    if (!postcodeInput) return;

    let typingTimer;

    postcodeInput.addEventListener("input", function () {
        clearTimeout(typingTimer);

        typingTimer = setTimeout(() => {
            fetchSuggestions(this.value);
        }, 300);
    });

    postcodeInput.addEventListener("change", function () {
        const selected = this.value;

        const postcode = suggestions.find(
            p => p.postcode === selected
        );

        console.log(postcode);
    });
}

document.addEventListener("DOMContentLoaded", initAddressAutocomplete);